// components/ui/ChartSkeleton.js
import React from 'react'
import { Skeleton, Box } from '@mui/material'
import styles from './chart-skeleton.module.css'

const ChartSkeleton = ({ isOn = false, height = 'default' }) => {
  const heightClass = height === 'default' ? styles.defaultHeight : styles.customHeight;
  const expandedClass = isOn ? styles.expandedHeight : '';

  return (
    <Box className={styles.container}>
      <Box className={styles.yAxisContainer}>
        <Skeleton variant="rounded" className={styles.yAxisTick} />
        <Skeleton variant="rounded" className={styles.yAxisTick} />
        <Skeleton variant="rounded" className={styles.yAxisTick} />
        <Skeleton variant="rounded" className={styles.yAxisTick} />
      </Box>
      <Box className={styles.chartsContainer}>
        <Skeleton 
          variant="rounded" 
          className={`${styles.chartBar} ${heightClass} ${expandedClass}`} 
        />
        <Skeleton 
          variant="rounded" 
          className={`${styles.chartBar} ${heightClass} ${expandedClass}`} 
        />
        <Skeleton 
          variant="rounded" 
          className={`${styles.chartBar} ${heightClass} ${expandedClass}`} 
        />
        <Skeleton 
          variant="rounded" 
          className={`${styles.chartBar} ${heightClass} ${expandedClass}`} 
        />
      </Box>
    </Box>
  )
}

export default ChartSkeleton